import React, { forwardRef } from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className = '',
  label,
  error,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-354">
        {label && <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-355">
            {label}
          </label>}
        <input ref={ref} className={`
            flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm placeholder:text-slate-400 
            focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
            ${className}
          `} {...props} data-id="element-356" />
        {error && <p className="mt-1 text-sm text-red-500" data-id="element-357">{error}</p>}
      </div>;
});
Input.displayName = 'Input';